/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} dana",
          "one": "za {0} dan",
          "other": "za {0} dana"
        },
        "past": {
          "few": "pre {0} dana",
          "one": "pre {0} dana",
          "other": "pre {0} dana"
        }
      },
      "day-narrow": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "pre {0} d.",
          "one": "pre {0} d.",
          "other": "pre {0} d."
        }
      },
      "day-short": {
        "-1": "juče",
        "-2": "prekjuče",
        "0": "danas",
        "1": "sutra",
        "2": "prekosutra",
        "future": {
          "few": "za {0} d.",
          "one": "za {0} d.",
          "other": "za {0} d."
        },
        "past": {
          "few": "pre {0} d.",
          "one": "pre {0} d.",
          "other": "pre {0} d."
        }
      },
      "hour": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} sata",
          "one": "za {0} sat",
          "other": "za {0} sati"
        },
        "past": {
          "few": "pre {0} sata",
          "one": "pre {0} sata",
          "other": "pre {0} sati"
        }
      },
      "hour-narrow": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} č.",
          "one": "za {0} č.",
          "other": "za {0} č."
        },
        "past": {
          "few": "pre {0} č.",
          "one": "pre {0} č.",
          "other": "pre {0} č."
        }
      },
      "hour-short": {
        "0": "ovog sata",
        "future": {
          "few": "za {0} č.",
          "one": "za {0} č.",
          "other": "za {0} č."
        },
        "past": {
          "few": "pre {0} č.",
          "one": "pre {0} č.",
          "other": "pre {0} č."
        }
      },
      "minute": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} minuta",
          "one": "za {0} minut",
          "other": "za {0} minuta"
        },
        "past": {
          "few": "pre {0} minuta",
          "one": "pre {0} minuta",
          "other": "pre {0} minuta"
        }
      },
      "minute-narrow": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "pre {0} min.",
          "one": "pre {0} min.",
          "other": "pre {0} min."
        }
      },
      "minute-short": {
        "0": "ovog minuta",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min."
        },
        "past": {
          "few": "pre {0} min.",
          "one": "pre {0} min.",
          "other": "pre {0} min."
        }
      },
      "month": {
        "-1": "prošlog meseca",
        "0": "ovog meseca",
        "1": "sledećeg meseca",
        "future": {
          "few": "za {0} meseca",
          "one": "za {0} mesec",
          "other": "za {0} meseci"
        },
        "past": {
          "few": "pre {0} meseca",
          "one": "pre {0} meseca",
          "other": "pre {0} meseci"
        }
      },
      "month-narrow": {
        "-1": "prošlog mes.",
        "0": "ovog mes.",
        "1": "sledećeg mes.",
        "future": {
          "few": "za {0} m.",
          "one": "za {0} m.",
          "other": "za {0} m."
        },
        "past": {
          "few": "pre {0} m.",
          "one": "pre {0} m.",
          "other": "pre {0} m."
        }
      },
      "month-short": {
        "-1": "prošlog mes.",
        "0": "ovog mes.",
        "1": "sledećeg mes.",
        "future": {
          "few": "za {0} mes.",
          "one": "za {0} mes.",
          "other": "za {0} mes."
        },
        "past": {
          "few": "pre {0} mes.",
          "one": "pre {0} mes.",
          "other": "pre {0} mes."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sledećeg kvartala",
        "future": {
          "few": "za {0} kvartala",
          "one": "za {0} kvartal",
          "other": "za {0} kvartala"
        },
        "past": {
          "few": "pre {0} kvartala",
          "one": "pre {0} kvartala",
          "other": "pre {0} kvartala"
        }
      },
      "quarter-narrow": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sledećeg kvartala",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "pre {0} kv.",
          "one": "pre {0} kv.",
          "other": "pre {0} kv."
        }
      },
      "quarter-short": {
        "-1": "prošlog kvartala",
        "0": "ovog kvartala",
        "1": "sledećeg kvartala",
        "future": {
          "few": "za {0} kv.",
          "one": "za {0} kv.",
          "other": "za {0} kv."
        },
        "past": {
          "few": "pre {0} kv.",
          "one": "pre {0} kv.",
          "other": "pre {0} kv."
        }
      },
      "second": {
        "0": "sada",
        "future": {
          "few": "za {0} sekunde",
          "one": "za {0} sekundu",
          "other": "za {0} sekundi"
        },
        "past": {
          "few": "pre {0} sekunde",
          "one": "pre {0} sekunde",
          "other": "pre {0} sekundi"
        }
      },
      "second-narrow": {
        "0": "sada",
        "future": {
          "few": "za {0} s.",
          "one": "za {0} s.",
          "other": "za {0} s."
        },
        "past": {
          "few": "pre {0} s.",
          "one": "pre {0} s.",
          "other": "pre {0} s."
        }
      },
      "second-short": {
        "0": "sada",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek."
        },
        "past": {
          "few": "pre {0} sek.",
          "one": "pre {0} sek.",
          "other": "pre {0} sek."
        }
      },
      "week": {
        "-1": "prošle nedelje",
        "0": "ove nedelje",
        "1": "sledeće nedelje",
        "future": {
          "few": "za {0} nedelje",
          "one": "za {0} nedelju",
          "other": "za {0} nedelja"
        },
        "past": {
          "few": "pre {0} nedelje",
          "one": "pre {0} nedelje",
          "other": "pre {0} nedelja"
        }
      },
      "week-narrow": {
        "-1": "prošle n.",
        "0": "ove n.",
        "1": "sledeće n.",
        "future": {
          "few": "za {0} n.",
          "one": "za {0} n.",
          "other": "za {0} n."
        },
        "past": {
          "few": "pre {0} n.",
          "one": "pre {0} n.",
          "other": "pre {0} n."
        }
      },
      "week-short": {
        "-1": "prošle ned.",
        "0": "ove ned.",
        "1": "sledeće ned.",
        "future": {
          "few": "za {0} ned.",
          "one": "za {0} ned.",
          "other": "za {0} ned."
        },
        "past": {
          "few": "pre {0} ned.",
          "one": "pre {0} ned.",
          "other": "pre {0} ned."
        }
      },
      "year": {
        "-1": "prošle godine",
        "0": "ove godine",
        "1": "sledeće godine",
        "future": {
          "few": "za {0} godine",
          "one": "za {0} godinu",
          "other": "za {0} godina"
        },
        "past": {
          "few": "pre {0} godine",
          "one": "pre {0} godine",
          "other": "pre {0} godina"
        }
      },
      "year-narrow": {
        "-1": "prošle g.",
        "0": "ove g.",
        "1": "sledeće g.",
        "future": {
          "few": "za {0} g.",
          "one": "za {0} g.",
          "other": "za {0} g."
        },
        "past": {
          "few": "pre {0} g.",
          "one": "pre {0} g.",
          "other": "pre {0} g."
        }
      },
      "year-short": {
        "-1": "prošle god.",
        "0": "ove god.",
        "1": "sledeće god.",
        "future": {
          "few": "za {0} god.",
          "one": "za {0} god.",
          "other": "za {0} god."
        },
        "past": {
          "few": "pre {0} god.",
          "one": "pre {0} god.",
          "other": "pre {0} god."
        }
      }
    },
    "locale": "sr-Latn"
  });
}